import React, { useState } from 'react'
import { Button, Dropdown, Tooltip } from 'antd';
import { setLocale, RefLanguage } from '../hooks/LanguageHooks';
import * as con from "../Constants"
import { TranslationOutlined } from '@ant-design/icons';

// const { Text } = Typography

function LanguageDropdown() {
    const [isHovered, setIsHovered] = useState(false);
    const i18n = RefLanguage();

    const handleMenuClick = (e) => {
        setLocale(e.key)
    }

    const menuItems = [
        {
            key: con.EN,
            label: 'EN'
        },
        {
            key: con.EE,
            label: 'EE'
        }
    ];

    const buttonStyle = {
        backgroundColor: isHovered ? "rgba(255, 255, 255, 0.15)" : "transparent",
        border: "none",
        color: "var(--text-color-1)",
        borderRadius: "8px",
        width: "5vh",
        height: "5vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "2.4vh",
        transition: "all 0.3s ease",
        transform: isHovered ? "scale(1.1)" : "scale(1)",
        padding: "0"
    };

    return (
        <Tooltip title={i18n.t('headerLanguage')} placement="bottom">
            <Dropdown menu={{ items: menuItems, onClick: handleMenuClick }} trigger={['click']}>
                <Button 
                    className="header-button"
                    style={buttonStyle}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <TranslationOutlined />
                </Button>
            </Dropdown>
        </Tooltip>
    )
}

export default LanguageDropdown
